import { ArticleHeading1, ArticleHeading3, ArticleHeading5 } from '@cian/ui-kit';
import * as style from './AccordionItem.css';
import { TPoints } from 'shared/types/points';
import clsx from 'clsx';

interface IAccordionItemProps extends TPoints {
  isNotDesktop: boolean;
  onToggleOpenDescr: VoidFunction;
  isOpenDescr: boolean;
}

export const AccrodionItem: React.FC<IAccordionItemProps> = ({
  id,
  title,
  description,
  isNotDesktop,
  onToggleOpenDescr,
  isOpenDescr,
}) => {
  const Title = isNotDesktop ? ArticleHeading3 : ArticleHeading1;

  const Descr = isNotDesktop ? ArticleHeading5 : ArticleHeading3;

  return (
    <div key={id} className={clsx(style['item'], isOpenDescr && style['active'], isNotDesktop && style['item-tablet'])}>
      <div className={style['title']} onClick={onToggleOpenDescr}>
        <Title>{title}</Title>
        <div className={style['arrow']} />
      </div>
      {isOpenDescr && (
        <div className={style['description']} key={description}>
          <Descr fontWeight="400">{description}</Descr>
        </div>
      )}
    </div>
  );
};
